/**
 * Helper di formattazione per le statistiche (numeri, valuta, date, mesi e giorni).
 */

const numberFormat = new Intl.NumberFormat('it-IT', { useGrouping: 'always' });
const compactFormat = new Intl.NumberFormat('it-IT', { notation: 'compact', maximumFractionDigits: 1 });
const currencyFormat = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', useGrouping: 'always' });

export const formatNumber = (value) => numberFormat.format(Number(value) || 0);

// dai 10.000 in su usa la forma compatta (es. 12,9 Mln)
export const formatCompact = (value) => Math.abs(value) >= 10000 ? compactFormat.format(value) : formatNumber(value);

export const formatCurrency = (value) => currencyFormat.format(Number(value) || 0);

export const formatPercent = (part, total) => total ? `${Math.round((part / total) * 100)}%` : '0%';

export const MONTHS = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
export const MONTHS_SHORT = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];

// chiavi dei mesi usate dal BE
export const MONTH_KEYS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

/**
 * Il BE identifica i giorni con due lettere: 'aa' = 1 ... 'az' = 26, 'ba' = 27 ... 'be' = 31.
 * Ritorna il numero del giorno (1-31) oppure null se la chiave non è valida.
 */
export function dayKeyToNumber(key) {
    if (!/^[ab][a-z]$/.test(key)) return null;
    const day = (key.charCodeAt(0) - 97) * 26 + (key.charCodeAt(1) - 97) + 1;
    return day >= 1 && day <= 31 ? day : null;
}

export const daysInMonth = (year, month) => new Date(year, month, 0).getDate();

/**
 * Data locale in formato YYYY-MM-DD (valore degli input type="date").
 */
export function toInputDate(date) {
    const pad = (n) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

/**
 * Converte un intervallo inclusivo di date (YYYY-MM-DD) nei filtri del BE:
 * inizio alla mezzanotte UTC del primo giorno, fine alla mezzanotte UTC del giorno dopo l'ultimo.
 */
export function rangeToIso(from, to) {
    const end = new Date(`${to}T00:00:00.000Z`);
    end.setUTCDate(end.getUTCDate() + 1);

    return {
        start: `${from}T00:00:00.000Z`,
        end: end.toISOString()
    };
}

export function formatShortDate(yyyyMmDd) {
    const [y, m, d] = yyyyMmDd.split('-');
    return `${d}/${m}/${y}`;
}
